module.exports = __webpack_public_path__ + "static/img/25SSDB-CKtRdoR0.ee8f09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/25SSDB-CKtRdoR0.png
// module id = LmpZ
// module chunks = 16